import React, { useEffect, useRef, useState } from "react";
import LeadStatusFilter from "./LeadStatusFilter";
import { useLocation, useNavigate } from "react-router-dom";
import AdminAppBar from "../adminComponents/AdminAppBar";
import StatusWiseAllLeads from "./StatusWiseAllLeads";
import LeadDbService from "../Services/LeadDbService";

const Leadfilter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedLeadStatusId, setSelectedLeadStatusId] = useState(
    location.state?.id||"L0CTrn0qwWlHWvq2gXDm"
  );
  console.log(location.state.leadCount);
  console.log(location.state?.id);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState([]);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [totalLead, setTotalLead] = useState(0);

  const handleLeadSelect = (leadId) => {
    setSelectedLeadStatusId(leadId);
    setNextPageToken("");
    setPrevPageToken("");
    setCurrentPage(1);
  };

  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const fetchLeadsData = async (pageToken = "", direction = "") => {
    try {
      setLoading(true);

      const userId = location?.state?.staffId || "";
      if (!selectedLeadStatusId) {
        console.error("Missing leadStatusId!");
        setLoading(false);
        return;
      }

      if (direction === "previous" && pages[currentPage - 2]) {
        console.log("Loading from cache:", pages[currentPage - 2]);
        setLeads(pages[currentPage - 2]);
        setCurrentPage((prev) => Math.max(1, prev - 1));
        setLoading(false);
        return;
      }

      const reqBody = {
        leadStatus: selectedLeadStatusId,
        next: direction === "next" ? pageToken : "",
        previous: direction === "previous" ? pageToken : "",
        direction,
        ...(userId && { userId }),
      };

      console.log("Request Body:", reqBody);

      const response = userId
        ? await LeadDbService.getParticularUserLeadStatusList(reqBody)
        : await LeadDbService.getLeadStatusList(reqBody);

      if (!response?.data) {
        throw new Error("Invalid API response");
      }

      console.log("All Leads:", response.data.leads);

      const leadsArray = response.data.leads || [];
      const nextToken = response.data.next || "";
      const prevToken = response.data.previous || "";
      const maxLeadCount = response.data.maxLeadCount || 0;

      if (isMounted.current) {
        setLeads(leadsArray);
        setPages((prevPages) => ({ ...prevPages, [currentPage]: leadsArray }));
        setNextPageToken(nextToken || null);
        setPrevPageToken(prevToken || null);
        setTotalLead(maxLeadCount);

        setCurrentPage((prev) => {
          if (direction === "next") return prev + 1;
          if (direction === "previous") return Math.max(1, prev - 1);
          return prev;
        });

        console.log(
          `Updated Page: ${
            currentPage +
            (direction === "next" ? 1 : direction === "previous" ? -1 : 0)
          }, Next: ${nextToken}, Prev: ${prevToken}`
        );
      }

      return response;
    } catch (error) {
      if (error.response?.status === 404) {
        if (isMounted.current) {
          setLeads([]);
          setPrevPageToken(null);
        }
        console.error("API returned 404 - No leads found!");
      } else {
        console.error("Error fetching leads:", error.message);
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    fetchLeadsData();
  }, [selectedLeadStatusId]);

  return (
    <div className="bg-appGrayBackground">
       <AdminAppBar />
      <div className="h-full py-20">
        <div className="px-8 flex pt-2 items-center">
          <svg
            onClick={() => navigate(-1)}
            className="cursor-pointer relative md:w-5 md:h-7 lg:w-5 lg:h-9"
            width="20"
            height="34"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>

          <div className="font-semibold md:mx-0 cursor-default text-3xl lg:mx-6 mx-14">
            {location.state?.staffName || "  All"}
          </div>
        </div>
        <div className="flex items-center gap-16 px-20  mt-6 ">
          <LeadStatusFilter
            leadCount={location.state.leadCount || 0}
            onLeadSelect={handleLeadSelect}
            id={location.state.id}
          />

          <StatusWiseAllLeads
            leads={leads}
            loading={loading}
            fetchLeadsData={fetchLeadsData}
            nextPageToken={nextPageToken}
            prevPageToken={prevPageToken}
            totalLead={totalLead}
            currentPage={currentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Leadfilter;
